export default "__VITE_ASSET__CFFDs$7V__"